import React, { useState, useEffect } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Menu, MenuItem, Box, Divider, Typography } from '@mui/material';
import moment from 'moment';
import http from '../../../api/http';

import Spinner from '../../Spinner';

import ModalNotifications from './ModalNotifications';

function NotificationMenu({ anchorEl, handleMenuOpen, handleMenuClose }) {
    /* VARIABLE DECELERATION
    -------------------------------------------------------------------------------------*/
    const [mdlNotification, setMdlNotifications] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);

    /* EVENT LISTENERS
    -------------------------------------------------------------------------------------*/
    useEffect(() => {
        if (handleMenuOpen) {
            getNotifications();
        }

        return () => {
            setLoading(true);
            return false;
        };
    }, [handleMenuOpen]);

    useEffect(() => {
        if (notifications.length) {
            setLoading(false);
        }
    }, [notifications]);

    /* ASYNC FUNCTIONS
    -------------------------------------------------------------------------------------*/
    async function getNotifications(pageNum = 1) {
        setLoading(true);
        try {
            const logger = await http.get('/notification', {
                params: { perPage: 20 },
            });
            setNotifications(logger.data?.data || []);
        } catch (error) {
            setNotifications([]);
        } finally {
            setLoading(false);
        }
    }

    /* EVENT FUNCTIONS
    -------------------------------------------------------------------------------------*/
    function openMdlNotifications() {
        setMdlNotifications(true);
    }

    function closeMdlNotifications() {
        setMdlNotifications(false);
    }
    /* RENDER APP
    -------------------------------------------------------------------------------------*/

    return (
        <>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={handleMenuOpen}
                onClose={handleMenuClose}
                onClick={handleMenuClose}
                component="div"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                MenuListProps={{
                    sx: {
                        '& .MuiMenuItem-root': {
                            whiteSpace: 'normal',
                            py: '8px',
                        },
                    },
                }}
                sx={{
                    '& .MuiMenu-list': {
                        p: '0',
                        minWidth: '300px',
                        maxWidth: '300px',
                    },
                }}
            >
                <MenuItem sx={{ py: '20px !important' }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h4">Notifications</Typography>
                        <Box sx={{}}>
                            You have {notifications.length} new notifications
                        </Box>
                    </Box>
                </MenuItem>
                <Divider sx={{ m: '0 !important' }} />
                <Box
                    sx={{
                        maxHeight: '290px',
                        overflow: 'hidden',
                        overflowY: 'auto',
                    }}
                >
                    {notifications.map((notification) => (
                        <MenuItem key={notification.notificationID}>
                            <Box>
                                <Box
                                    sx={{ fontWeight: '700', fontSize: '16px' }}
                                >
                                    {notification.title}
                                </Box>
                                <Typography>
                                    {notification.body}
                                    {' '}
                                    {moment(notification.createdAt).format('l - LT')}
                                </Typography>
                            </Box>
                        </MenuItem>
                    ))}
                </Box>
                <Divider />
                <MenuItem
                    onClick={openMdlNotifications}
                    sx={{ textAlign: 'center', justifyContent: 'center' }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            color: 'secondary.main',
                            py: '6px',
                        }}
                    >
                        <Box sx={{ textTransform: 'uppercase' }}>View all</Box>
                        <ArrowForwardIcon />
                    </Box>
                </MenuItem>
            </Menu>

            {mdlNotification && (
                <ModalNotifications
                    openModal={mdlNotification}
                    closeModal={closeMdlNotifications}
                />
            )}
        </>
    );
}

export default NotificationMenu;
